<script lang="ts">
    import { Link, useLocation } from "svelte-navigator";
    import { Button, Offcanvas } from "sveltestrap";

    let open = false;
    const toggle = () => (open = !open);
    const location = useLocation();
</script>

<div class="nav-button">
    <div class="nav-left">
        {#if $location.pathname.split("/")[1]}
            <h3>{$location.pathname.split("/")[1]}</h3>
        {:else}
            <h3>Kari57 🐦</h3>
        {/if}
    </div>
    <div class="nav-right">
        <Button on:click={toggle}>=</Button>
    </div>
</div>
<Offcanvas
    class="off-canvas"
    isOpen={open}
    {toggle}
    header=""
    placement="start"
>
    <div on:click={toggle}>
        <Link to="/">Etusivu</Link>
        <Link to="linnut">Linnut</Link>
        <Link to="galleriat">Galleriat</Link>
        <Link to="matkat">Matkat</Link>
        <Link to="viikonkuva">Viikon Kuva</Link>
        <Link to="kuukaudenkuva">Kuukauden Kuva</Link>
    </div>

    <div class="nav-link">
        <a
            href="https://www.instagram.com/kari57.kyto"
            class="fa fa-instagram"
        />
    </div>
</Offcanvas>

<style>

    :global(.offcanvas-header) {
        background-color: rgb(59, 59, 59);
    }

    :global(.offcanvas-body) {
        background-color: rgb(59, 59, 59);
    }

    .nav-button {
        z-index: 1;
        padding: 10px;
        position: fixed;
        display: flex;
        justify-items: end;
        align-items: center;
        width: 100%;
        top: 0px;
        right: 0px;
        background: rgb(59, 59, 59);
        /* background: linear-gradient(0deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%); */
        border-bottom: 1px solid rgb(88, 88, 88);
    }

    .nav-link {
        display: flex;
        justify-content: start;
        align-items: center;
        margin-left: auto;
        margin-top: 35px;
        margin-right: 25px;
        margin-left: 10px;
        padding: 0;
    }

    :global(.off-canvas a) {
        display: block;
        font-size: x-large;
        padding: 10px 10px;
        text-decoration: none;
        color: rgb(24, 24, 24);
    }

    :global(.nav-left h3) {
        font-size: x-large;
        font-weight: normal;
        padding: 0px;
        margin: 0px;
        margin-left: 15px;
        color: rgb(0, 0, 0);
    }

    :global(.nav-left h3:first-letter) {
        text-transform: capitalize;
    }

    .nav-right {
        margin-left: auto;
        right: 0;
    }

    :global(.off-canvas a[aria-current]) {
        color: rgb(90, 92, 211);
    }

    .fa {
        font-size: 30px;
        text-align: center;
        text-decoration: none;
        padding: 3px 5px;
        border-radius: 10px;
        color: white;
        background: radial-gradient(
                circle farthest-corner at 35% 90%,
                #fec564,
                transparent 50%
            ),
            radial-gradient(
                circle farthest-corner at 0 140%,
                #fec564,
                transparent 50%
            ),
            radial-gradient(
                ellipse farthest-corner at 0 -25%,
                #5258cf,
                transparent 50%
            ),
            radial-gradient(
                ellipse farthest-corner at 20% -50%,
                #5258cf,
                transparent 50%
            ),
            radial-gradient(
                ellipse farthest-corner at 100% 0,
                #893dc2,
                transparent 50%
            ),
            radial-gradient(
                ellipse farthest-corner at 60% -20%,
                #893dc2,
                transparent 50%
            ),
            radial-gradient(
                ellipse farthest-corner at 100% 100%,
                #d9317a,
                transparent
            ),
            linear-gradient(
                #6559ca,
                #bc318f 30%,
                #e33f5f 50%,
                #f77638 70%,
                #fec66d 100%
            );
    }

    /* Add a hover effect if you want */
    .fa:hover {
        opacity: 0.7;
    }
</style>
